/* @flow */
import Container from 'components/Container.jsx';
import Footer from 'components/Footer.jsx';
import React from 'react';
import cx from 'classnames';
import './styles/UnauthenticatedView.scss';

class UnauthenticatedView extends React.Component {
  static propTypes = {
    title: React.PropTypes.node,
  };

  render() {
    const { title, className, children } = this.props;

    return (
      <div>
        <main className={cx('UnauthenticatedView', className)}>
          <Container>
            {title && <h1 className="UnauthenticatedView-title">{title}</h1>}
            {children}
          </Container>
        </main>
        <Footer />
      </div>
    );
  }
}

export default UnauthenticatedView;



// WEBPACK FOOTER //
// ./src/auth/components/UnauthenticatedView.jsx